import { render, staticRenderFns } from "./BatchOrders.vue?vue&type=template&id=a01860f2"
import script from "./BatchOrders.vue?vue&type=script&lang=js"
export * from "./BatchOrders.vue?vue&type=script&lang=js"
import style0 from "./BatchOrders.vue?vue&type=style&index=0&id=a01860f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports